export const version = '0.737.0'
export const chameleonWebVersion = '0.0.0-1.36.0-6.backport-chameleon-web-7-x-x.329462b'
export const chameleonCoreVersion = '0.0.0-1.36.0-6.backport-chameleon-web-7-x-x.329462b'
